<ion-header>
  <ion-toolbar>
    <div class="d-flex ion-justify-content-between ion-align-items-center px-xs">
      <ion-button *ngIf="navigationService.modalStackLength"
                  (click)="onBack()" fill="clear">
        <ion-icon name="arrow-back-outline" class="pr-sm"></ion-icon>
        <div class="ts-body">Indietro</div>
      </ion-button>
      <ion-button *ngIf="!disableClose()"
                  (click)="onClose()" fill="clear">
        <span class="material-symbols-outlined">close</span>
        <div class="ts-body">Chiudi</div>
      </ion-button>
    </div>
  </ion-toolbar>
</ion-header>


